import { createSyncAction, RxEventEmitter } from '@bimser/core';
import { Subscription } from 'rxjs';
import { put } from 'redux-saga/effects';

const listenMessage = () => {
	return new Promise(resolve => {
		let sub: Subscription = null;
		RxEventEmitter.listen('SYSTEM_SOCKET', {
			next: (message: any) => {
				if (message?.type.startsWith('COMMON.')) {
					resolve(message);
				}
			}
		}).then(subscription => {
			sub = subscription;
		});
	});
};

export default function* watchManager() {
	while (true) {
		const message = yield listenMessage();
		yield put(createSyncAction(`REALTIME.${message.type}`, message.payload));
	}
}
